import { createElement, useState } from 'react';
import { Form, Field, Input, Icon } from '@alifd/next';
const Search = function Search({ labelAlign, labelName, labelSize, labelCol, wrapperCol, style: styleOption = {}, ...otherProps }) {
    const [inputval, setInputval] = useState('');
    const formItemLayout = {
        labelCol: { span: labelCol },
        wrapperCol: { span: wrapperCol }
    };
    const field = Field.useField({
        autoUnmount: false,
        values: { inline: false, labelAlign: "left" }
    });
    return (createElement(Form, { field: field, labelAlign: labelAlign, size: labelSize, ...formItemLayout, style: { ...styleOption } },
        createElement(Form.Item, { label: labelName, name: "inlineUser" },
            createElement(Input, { onChange: (e) => setInputval(e), innerAfter: createElement(Icon, { type: "search", size: "xs", onClick: (e) => otherProps.onClick(e, inputval), style: { margin: 4 } }), placeholder: `请输入${labelName}` }))));
};
export default Search;
